import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Proteção CSRF: o backend exige X-Requested-With em toda escrita sob /api.
// axios.defaults não alcança fetch() puro, então embrulhamos o fetch global
// para injetar o header em toda chamada à API — cobre os fetch() espalhados
// (formulário público, painel de investigação) sem tocar em cada um.
const _fetch = window.fetch.bind(window);
window.fetch = (input, init) => {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  if (!url.includes('/api/')) return _fetch(input, init);
  // Usa Headers para preservar os headers existentes seja qual for a forma:
  // objeto literal, instância Headers, ou os headers de um Request como 1º arg.
  // Um spread simples ({...init.headers}) descartaria um Headers (não enumerável).
  const headers = new Headers((init && init.headers) || (input && input.headers) || undefined);
  headers.set('X-Requested-With', 'XMLHttpRequest');
  return _fetch(input, { ...(init || {}), headers });
};

// Configurações globais
window.addEventListener('unhandledrejection', event => {
  console.error('Promise rejeitada não tratada:', event.reason);
});

// Interceptar erros do React
window.addEventListener('error', event => {
  console.error('Erro global:', event.error);
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 